import ApiService from '@/services/api.service';

export default {
  sendRequest: ({
    url,
    method,
    data = null,
    mutation,
    errorMutation,
    context: { commit },
    useProp = false,
    globalLoaderMutation,
  }) => {
    commit(errorMutation, null);
    return ApiService[method](url, data)
      .then((response) => {
        commit(mutation, useProp ? data : response.data.Data);
        if (globalLoaderMutation) {
          commit(globalLoaderMutation);
        }
        return response;
      }).catch(({ response }) => {

        if (response.data && response.data.Message) {
          commit(errorMutation, response.data.Data || response.data.Message);
        }

        return response;
      });
  },
};
